import { apiCall } from './generated/gqlClient';

const getRandomProviders = () => {
  const query = `
    query getRandomProviders {
      getRandomProviders {
        centers {
          id
          name
          categories {
            id
            name
          }
          description
          address
          membershipsCounter
          userHasMembership
          images {
            medium
          }
        }
        professionals {
          id
          name
          categories {
            id
            name
          }
          description
          address
          membershipsCounter
          userHasMembership
          images {
            medium
          }
        }
      }
    }
  `;
  return apiCall({ query });
};
const getRandomProvidersAlsoByKeywordOrAddressApiRequest = (keyword, city, country, type) => {
  const query = `
    query getRandomProvidersAlsoByKeywordOrAddress($keyword: String, $city: String, $country: String, $type: String) {
      getRandomProvidersAlsoByKeywordOrAddress(keyword: $keyword, city: $city, country: $country, type: $type) {
        centers {
          id
          name
          type
          categories {
            id
            name
          }
          description
          address
          membershipsCounter
          userHasMembership
          images {
            medium
          }
        }
        professionals {
          id
          name
          type
          categories {
            id
            name
          }
          description
          address
          membershipsCounter
          userHasMembership
          images {
            medium
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { keyword, city, country, type } });
};

const getProviderDetails = async providerId => {
  const query = `
    query getProviderDetails($providerId: Int!) {
      getProviderDetails(id: $providerId) {
        id
        name
        description
        categories {
          id
          name
        }
        type
        address
        postcode
        phone
        latitude
        longitude
        acceptPayments
        onlineDiscount
        url
        blog
        facebook
        twitter
        linkedin
        instagram
        skype
        youtube
        email
        active
        userHasMembership
        freeCancellationHours
        images {
          medium
        }
        memberships {
          id
          name
          offers {
            id
            name
            description
            price
            sessionsCounter
            reservationsCounter
            membershipType
            duration
            durationType
            startTime
            endTime
            allInclusive
            services {
              id
              name
            }
          }
        }
        bundleGroups {
          id
          name
          bundles {
            id
            name
            description
            price
            duration
            durationType
            memberships {
              id
              name
              membershipType
              allInclusive
              description
              duration
              durationType
              reservationsCounter
              sessionsCounter
              rules {
                id
                name
                type
                amount
                period
              }
            }
          }
        }
        services {
          id
          name
          offers {
            id
            name
            description
            serviceId
            price
            duration
            startTime
            endTime
            resources {
              id
              name
            }
          }
        }
        courses {
          id
          name
          offers {
            id
            name
            description
            price
            duration
            model
          }
        }
        events {
          id
          name
          offers {
            id
            name
            description
            price
            duration
            model
          }
        }
        schedules {
          day
          workTime {
            startTime
            endTime
          }
          break {
            startTime
            endTime
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { providerId: +providerId } });
};

const getSearchProviders = async (categoryId, cityId, providerType, keyword, onlyMyMemberships) => {
  const query = `
    query getProviders($categoryId: Int, $cityId: Int, $providerType: String, $keyword: String, $onlyMyMemberships: Boolean) {
      getProviders(categoryId: $categoryId, cityId: $cityId, providerType: $providerType, keyword: $keyword, onlyMyMemberships: $onlyMyMemberships) {
        id
        name
        description
        type
        address
        userHasMembership
        categories {
          id
          name
        }
        membershipsCounter
        images {
          medium
        }
      }
    }
  `;
  return apiCall({ query, variables: { categoryId, cityId, providerType, keyword, onlyMyMemberships } });
};

const getClassDetails = async classId => {
  const query = `
    query getClassDetails($classId: Int!) {
      getClassDetails(id: $classId) {
        id
        name
        description
        price
        duration
        model
        serviceId
        providerId
        sessions {
          id
          startTime
          endTime
          availableCapacity
          locationType
          price
          isSessionBought
          subscriptionId
          resources {
            id
            name
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { classId: +classId } });
};

const getAllCategories = async () => {
  const query = `
    query getAllCategories {
      getAllCategories {
        id
        name
        type
      }
    }
  `;
  return apiCall({ query });
};

const getAllCities = async () => {
  const query = `
    query getCities {
      getCities {
        id
        name
      }
    }
  `;
  return apiCall({ query });
};

const getMyMemberships = async () => {
  const query = `
    query getMyMemberships {
      getMyMemberships {
        id
        sessionsCounter
        isActive
        startTime
        endTime
        membership {
          id
          name
        }
      }
    }
  `;
  return apiCall({ query });
};

const getAvailableBookings = async (providerId, startTime) => {
  const query = `
    query getAvailableBookings($providerId: Int!, $startTime: DateTime!) {
      getAvailableBookings(providerId: $providerId, startTime: $startTime) {
        id
        name
        description
        startTime
        endTime
        type
        entityType
        duration
        availableCapacity
        classId
        pricingModel
        price
        locationType
        isSessionBought
      }
    }
  `;
  return apiCall({ query, variables: { providerId, startTime } });
};

export {
  getAllCategories,
  getAllCities,
  getAvailableBookings,
  getClassDetails,
  getMyMemberships,
  getProviderDetails,
  getRandomProviders,
  getRandomProvidersAlsoByKeywordOrAddressApiRequest,
  getSearchProviders,
};
